import axios from 'axios';

export default {
    methods: {
        async fleteDescuentoIndex(d, ok, err) {
            try {
                let r = await axios.get('flete/descuento?page=' + d.page, {params: d})
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteDescuentoStore(d, ok, err) {
            try {
                let r = await axios.post('flete/descuento', d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteDescuentoUpdate(id, d, ok, err) {
            try {
                let r = await axios.put('flete/descuento/' + id, d)
                ok(r.data)
            } catch (e) {
                err(e.response.data)
            }
        },
        async fleteDescuentoShow(id, ok, err) {
            try {
                let r = await axios.get('flete/descuento/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteDescuentoDestroy(id, ok, err) {
            try {
                let r = await axios.delete('flete/descuento/' + id);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
        async fleteDescuentoTotal(d, ok, err) {
            try {
                let r = await axios.post('flete/descuento/total', d);
                ok(r.data)
            } catch (e) {
                err(e)
            }
        },
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/mixins/flete_descuento.js